import React from "react";
import { TouchableOpacity, View, Image } from "react-native";
import { createStackNavigator } from "@react-navigation/stack";
// import DocReader from "../containers/DocReader";
import LoadingScreen from "../containers/LoadingScreen";
import LandingScreen from "../containers/LandingScreen";
import MaintenanceScreen from "../containers/Maintenance";
import EventDetails from "../containers/EventDetails";
import GoodDealDetails from "../containers/GoodDealDetails";
import AppInfos from "../containers/AppInfos";
import ProfileUpdate from "../containers/ProfileUpdate";
import EventInterestedUsers from "../containers/EventInterestedUsers";
import Post from "../containers/Post";
import Profile from "../containers/Profile";
import SelectTemplate from "../containers/SelectTemplate";
import SelectTemplateDate from "../containers/SelectTemplateDate";
import CameraScreen from "../containers/CameraScreen";
import Chat from "../containers/Chat";
import ImageZoom from "../containers/ImgZoom";
import BottomTabNavigator from "./BottomTabsNavigator";
import { BUSINESS_NAME } from "../config/constants";
import commonStyles, {
  COLOR2,
  COLOR5,
  WHITE_COLOR
} from "../styles/commonStyles";
import { t } from "../services/i18n";
import { getImage } from "../assets/Images";
import { MaterialCommunityIcons } from "@expo/vector-icons";
import { RESET_POST, CLEAR_PUBLISH, LOGOUT } from "../actions/types";
import CommunityDetails from "../containers/CommunityDetails";

const Stack = createStackNavigator();

const DEFAULT_HEADER_STYLE = {
  backgroundColor: COLOR5,
  elevation: 0,
  shadowOpacity: 0,
  borderBottomWidth: 0
};

function getTemplateHeaderStyle(displayPreview) {
  if (displayPreview) {
    return {
      backgroundColor: COLOR5
    };
  }
  return DEFAULT_HEADER_STYLE;
}

function getTemplateHeaderRight(onClickPreview, displayPreview) {
  const {
    flex1,
    bgWhite,
    bgColor2,
    justifyContentCenter,
    alignItemsCenter,
    h100p
  } = commonStyles;

  return () => (
    <TouchableOpacity style={flex1} onPress={onClickPreview}>
      <View
        style={[
          displayPreview ? bgWhite : bgColor2,
          alignItemsCenter,
          justifyContentCenter,
          h100p,
          {
            width: 56,
            paddingBottom: 3
          }
        ]}
      >
        <MaterialCommunityIcons
          name="eye-check"
          color={displayPreview ? COLOR2 : WHITE_COLOR}
          size={28}
        />
      </View>
    </TouchableOpacity>
  );
}

function getHeaderLeftBack(navigation, callback) {
  const {
    flex1,
    bgColor2,
    justifyContentCenter,
    alignItemsCenter
  } = commonStyles;

  return () => (
    <TouchableOpacity
      style={flex1}
      onPress={() => {
        if (navigation.canGoBack()) {
          navigation.goBack();
        }
        callback && callback();
      }}
    >
      <View
        style={[
          bgColor2,
          alignItemsCenter,
          justifyContentCenter,
          {
            height: "100%",
            width: 56,
            paddingBottom: 3
          }
        ]}
      >
        <Image style={{ width: 20, height: 20 }} source={getImage("back")} />
      </View>
    </TouchableOpacity>
  );
}

export const createRootAppStackNavigator = ({
  dispatch,
  user,
  accessDenied,
  isFetchingError,
  navigation,
  onClickPreview,
  displayPreview
}) => {
  return (
    <Stack.Navigator
      screenOptions={{
        title: BUSINESS_NAME,
        headerTitleAlign: "left",
        headerStyle: DEFAULT_HEADER_STYLE,
        headerTintColor: WHITE_COLOR,
        headerTitleStyle: {
          fontFamily: "fontBold",
          textTransform: "uppercase"
        }
      }}
    >
      {Boolean(user && !isFetchingError) ? (
        user.needUpdate ? (
          <>
            <Stack.Screen
              name="ProfileUpdateScreen"
              component={ProfileUpdate}
              options={{
                title: t("menu:profile"),
                headerLeft: getHeaderLeftBack(navigation, () =>
                  dispatch({
                    type: LOGOUT
                  })
                )
              }}
            />
            <Stack.Screen
              name="CameraScreen"
              component={CameraScreen}
              options={{ headerShown: false }}
            />
          </>
        ) : (
          <>
            <Stack.Screen name="TabScreen" component={BottomTabNavigator} />
            <Stack.Screen
              name="ProfileUpdateScreen"
              component={ProfileUpdate}
              options={{
                title: t("menu:profile"),
                headerLeft: getHeaderLeftBack(navigation)
              }}
            />
            <Stack.Screen
              name="CameraScreen"
              component={CameraScreen}
              options={{ headerShown: false }}
            />
            <Stack.Screen
              name="SelectActivityScreen"
              component={SelectTemplate.SelectActivity}
              options={{
                title: t("menu:instantsharing"),
                headerLeft: getHeaderLeftBack(navigation)
              }}
            />
            <Stack.Screen
              name="SelectProposalScreen"
              component={SelectTemplate.SelectProposal}
              options={{
                title: t("menu:needservice"),
                headerLeft: getHeaderLeftBack(navigation)
              }}
            />
            <Stack.Screen
              name="SelectTemplateScreen"
              component={SelectTemplate.SelectTemplate}
              options={{
                title: t("menu:templates"),
                headerLeft: getHeaderLeftBack(navigation)
              }}
            />
            <Stack.Screen
              name="SelectTemplateDateScreen"
              component={SelectTemplateDate}
              options={({ route }) => {
                return {
                  headerTitle: route?.params?.name,
                  headerLeft: getHeaderLeftBack(navigation, () =>
                    dispatch({ type: CLEAR_PUBLISH })
                  ),
                  headerRight: getTemplateHeaderRight(
                    onClickPreview,
                    displayPreview
                  ),
                  headerStyle: getTemplateHeaderStyle(displayPreview)
                };
              }}
            />
            <Stack.Screen
              name="PostScreen"
              component={Post}
              options={{
                title: t("menu:snapshot"),
                headerLeft: getHeaderLeftBack(navigation, () =>
                  dispatch({ type: RESET_POST })
                )
              }}
            />
            <Stack.Screen
              name="EventInterestedUsersScreen"
              component={EventInterestedUsers}
              options={{
                title: t("menu:post"),
                headerLeft: getHeaderLeftBack(navigation)
              }}
            />
            <Stack.Screen
              name="ProfileScreen"
              component={Profile}
              options={{
                title: t("menu:profile"),
                headerLeft: getHeaderLeftBack(navigation)
              }}
            />
            <Stack.Screen
              name="GoodDealDetailsScreen"
              component={GoodDealDetails}
              options={({ route }) => {
                return {
                  title: route?.params?.title
                    ? route.params.title
                    : t("menu:localLife"),
                  headerLeft: getHeaderLeftBack(navigation)
                };
              }}
            />
            <Stack.Screen
              name="CommunityDetailsScreen"
              component={CommunityDetails}
              options={{
                title: t("menu:camping"),
                headerLeft: getHeaderLeftBack(navigation)
              }}
            />
            <Stack.Screen
              name="ChatScreen"
              component={Chat}
              options={({ route }) => {
                return {
                  headerTitle: route?.params?.title,
                  headerLeft: getHeaderLeftBack(navigation),
                  headerTitleStyle: {
                    textTransform: "none"
                  }
                };
              }}
            />
            <Stack.Screen
              name="ImageZoomScreen"
              component={ImageZoom}
              options={{
                title: t("menu:zoom"),
                headerLeft: getHeaderLeftBack(navigation)
              }}
            />
            <Stack.Screen
              name="AppInfosScreen"
              component={AppInfos}
              options={{
                title: t("menu:about"),
                headerLeft: getHeaderLeftBack(navigation)
              }}
            />
            {/* <Stack.Screen
              name="CGUScreen"
              component={DocReader}
              options={{
                title: t("menu:CGU"),
                headerLeft: getHeaderLeftBack(navigation)
              }}
            /> */}
            {/* <Stack.Screen
              name="PdfWelcomeScreen"
              component={DocReader}
              options={{
                title: t("menu:welcomepdf"),
                headerLeft: getHeaderLeftBack(navigation)
              }}
            /> */}
            <Stack.Screen
              name="MaintenanceScreen"
              component={MaintenanceScreen}
              options={{ headerShown: false }}
            />
          </>
        )
      ) : accessDenied || isFetchingError ? (
        <>
          <Stack.Screen
            name="LandingScreen"
            component={LandingScreen}
            options={{ headerShown: false }}
          />
          <Stack.Screen
            name="AppInfosScreen"
            component={AppInfos}
            options={{
              title: t("menu:about"),
              headerLeft: getHeaderLeftBack(navigation)
            }}
          />
          {/* <Stack.Screen
            name="CGUScreen"
            component={DocReader}
            options={{
              title: t("menu:CGU"),
              headerLeft: getHeaderLeftBack(navigation)
            }}
          /> */}
          <Stack.Screen
            name="GoodDealDetailsScreen"
            component={GoodDealDetails}
            options={({ route }) => {
              return {
                title: route?.params?.title
                  ? route.params.title
                  : t("menu:localLife"),
                headerLeft: getHeaderLeftBack(navigation)
              };
            }}
          />
          <Stack.Screen
            name="SelectTemplateDateScreen"
            component={SelectTemplateDate}
            options={({ route }) => {
              return {
                headerTitle: route?.params?.name,
                headerLeft: getHeaderLeftBack(navigation, () =>
                  dispatch({ type: CLEAR_PUBLISH })
                ),
                headerRight: getTemplateHeaderRight(
                  onClickPreview,
                  displayPreview
                ),
                headerTitleStyle: {
                  textTransform: "none"
                },
                headerStyle: getTemplateHeaderStyle(displayPreview)
              };
            }}
          />
          <Stack.Screen
            name="EventDetailsScreen"
            component={EventDetails}
            options={{
              title: t("menu:post"),
              headerLeft: getHeaderLeftBack(navigation)
            }}
          />
          <Stack.Screen
            name="MaintenanceScreen"
            component={MaintenanceScreen}
            options={{ headerShown: false }}
          />
        </>
      ) : (
        <>
          <Stack.Screen
            name="LoadingScreen"
            component={LoadingScreen}
            options={{ headerShown: false }}
          />
          <Stack.Screen
            name="MaintenanceScreen"
            component={MaintenanceScreen}
            options={{ headerShown: false }}
          />
        </>
      )}
    </Stack.Navigator>
  );
};
